var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 8.66634V1.99967C15.8334 1.08301 15.0834 0.333008 14.1667 0.333008H2.50004C1.58337 0.333008 0.833374 1.08301 0.833374 1.99967V8.66634C0.833374 9.58301 1.58337 10.333 2.50004 10.333H14.1667C15.0834 10.333 15.8334 9.58301 15.8334 8.66634ZM14.1667 8.66634H2.50004V1.99967H14.1667V8.66634ZM8.33337 2.83301C6.95004 2.83301 5.83337 3.94967 5.83337 5.33301C5.83337 6.71634 6.95004 7.83301 8.33337 7.83301C9.71671 7.83301 10.8334 6.71634 10.8334 5.33301C10.8334 3.94967 9.71671 2.83301 8.33337 2.83301ZM19.1667 2.83301V11.9997C19.1667 12.9163 18.4167 13.6663 17.5 13.6663H3.33337C3.33337 12.833 3.33337 12.9163 3.33337 11.9997H17.5V2.83301C18.4167 2.83301 18.3334 2.83301 19.1667 2.83301Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.d234324ddf51e3714787dc2f60fae6d7.svg";
export { ForwardRef as ReactComponent };